import { IdentityOrganization } from '@reg/shared/model';

export class IdentityOrganizationPerson {
    public id: string = null;
    public organizationId: string = null;
    public personId: string = null;
    public identifier: string = null;

    public isUsaWrestling(): boolean {
        return this.organizationId === IdentityOrganization.ID_USA_WRESTLING;
    }

    public isTrackwrestling(): boolean {
        return this.organizationId === IdentityOrganization.ID_TRACKWRESTLING;
    }

    public clone(): IdentityOrganizationPerson {
        const clone: IdentityOrganizationPerson = new IdentityOrganizationPerson();
        clone.id = this.id;
        clone.organizationId = this.organizationId;
        clone.personId = this.personId;
        clone.identifier = this.identifier;

        return clone;
    }

    /**
     * Serialize to a json api format
     */
    public serialize(): string {
        const json: any = {};
        json.data = {};
        json.data.type = 'organizationPerson';
        json.data.id = this.id;
        json.data.attributes = {
            organizationId: this.organizationId,
            personId: this.personId,
            identifier: this.identifier,
        };

        return JSON.stringify(json);
    }

    /**
     * Deserialize from json api format
     */
    public deserialize(json: any): IdentityOrganizationPerson {
        const data: any = json['data'] || json;
        const attrs: any = data.attributes || [];

        this.id = data.id;
        this.organizationId = attrs.organizationId;
        this.personId = attrs.personId;
        this.identifier = attrs.identifier;

        return this;
    }
}
